import { createFileRoute, redirect } from '@tanstack/react-router'
import { createClient } from '@connectrpc/connect'
import { create } from '@bufbuild/protobuf'
import { CortadoService, GetPublicSignupEnabledRequestSchema } from '../gen/cortado/v1/cortado_pb'
import { connectTransport } from '../lib/connect-transport'
import { Signup } from '../components/auth/Signup'

export const Route = createFileRoute('/signup')({
  beforeLoad: async () => {
    const client = createClient(CortadoService, connectTransport)
    const res = await client.getPublicSignupEnabled(
      create(GetPublicSignupEnabledRequestSchema, {})
    )
    if (!res.enabled) throw redirect({ to: '/login' })
  },
  component: Signup,
})
